import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";
import animationData from "../assets/Animation - 1713432420781.json";
import "./Loader.scss";
const Loader = () => {
  const containerRef = useRef(null);
  useEffect(() => {
    const anim = lottie.loadAnimation({
      container: containerRef.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: animationData,
    });

    // Cleanup animation when component unmounts
    return () => {
      anim.destroy();
    };
  }, []);
  return (
    <>
      <div className="parent-container">
        <div className="animation-container" ref={containerRef}></div>
      </div>
      {/* <div className="loader-parent" ref={containerRef}></div> */}
    </>
  );
};

export default Loader;
